import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const BridesmaidPersonalPage = () => {
  const { bridesmaidName } = useParams();
  const [showProposal, setShowProposal] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showSplash, setShowSplash] = useState(true);
  const [showCard, setShowCard] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // Bridesmaid data
  const bridesmaids = {
    kate: {
      name: 'Kate',
      displayName: 'Kate',
      image: '/images/bridesmaids/kate.jpg',
      personalMessage: 'Mi Kate, siempre has sido un ejemplo para mí. Me has mostrado el camino correcto, enseñándome a ser mejor y a crecer hasta convertirme en quien soy hoy. Y ahora que ya la diferencia de edad no se siente tanto en nuestra relación, sigues siendo ese apoyo, ese consejo y, aún más, esa amiga con la que siempre puedo contar. Sería muy feliz si me acompañaras como una de mis damas.',
    },
    lala: {
      name: 'Lala',
      displayName: 'Lala',
      image: '/images/bridesmaids/lala.jpg',
      personalMessage: 'Lali, siempre has sido mi compañera a lo largo de la vida. Has estado conmigo en cada etapa incondicionalmente. Me has apoyado como nadie más, y aunque somos muy diferentes, siempre hemos encontrado la manera de caminar juntas, y eso es lo que hace que nuestro lazo sea tan especial. Y una vez más sería muy feliz si me acompañaras como una de mis damas.',
    },
    lu: {
      name: 'Lu',
      displayName: 'Lu',
      image: '/images/bridesmaids/lu.jpg',
      personalMessage: 'Lu, cuando te conocí me costaba abrirme a nuevas personas, pero contigo todo fue tan fácil. Tu carisma, tu alegría y esa forma tan auténtica de ser hicieron que te convirtieras en una amiga muy especial para mí. Te quiero muchísimo y me siento muy agradecida por haberte encontrado en mi camino y por tu apoyo cada vez que lo he necesitado. Sería muy feliz si me acompañaras como una de mis damas.',
    },
    andy: {
      name: 'Andy',
      displayName: 'Andy',
      image: '/images/bridesmaids/andy.jpg',
      personalMessage: 'Andy, te tengo un cariño enorme y quiero agradecerte por siempre hacerme sentir parte, por tenerme en cuenta y por incluirme incluso cuando a mí me cuesta un poquito (jajaja). Tu amistad ha sido un verdadero regalo: siempre divertida, honesta, sin tapujos y con esa sinceridad única que tanto valoro. Sé que si necesito a alguien que me diga las cosas como son, esa serías tú. Sería muy feliz si me acompañaras como una de mis damas. ',
    },
    pau: {
      name: 'Pau',
      displayName: 'Pau',
      image: '/images/bridesmaids/pau.jpg',
      personalMessage: 'Perri, mi hermana por elección mi gemeli, nuestro amor siempre ha sido único (¡hasta de las greñas! jaja). Pero más allá de las bromas, lo que nos une es mucho más fuerte: siempre hemos estado ahí la una para la otra, apoyándonos, escuchándonos y acompañándonos sin importar la distancia. Eres una parte muy especial de mi vida, y no imagino este día sin ti a mi lado. Sería muy feliz si me acompañaras como una de mis damas.'
    }
  };

  const currentBridesmaid = bridesmaids[bridesmaidName?.toLowerCase()];

  useEffect(() => {
    if (currentBridesmaid) {
      // Single splash screen experience for all devices
      const timer1 = setTimeout(() => {
        setShowSplash(false);
        setTimeout(() => {
          setShowCard(true);
          setShowProposal(true);
          setShowDetails(true);
        }, 300); // Wait for splash fade out
      }, 5000); // Show splash for 3 seconds

      const timer2 = setTimeout(() => setShowConfetti(true), 5000);

      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    }
  }, [currentBridesmaid]);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  // ConfettiPage integration
  useEffect(() => {
    if (showConfetti) {
      const loadConfettiScript = () => {
        return new Promise((resolve, reject) => {
          if (document.querySelector('script[src*="canvas-confetti"]')) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.6.0/dist/confetti.browser.min.js';
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      const triggerConfetti = async () => {
        try {
          await loadConfettiScript();
          
          setTimeout(() => {
            if (window.confetti) {
              const duration = 5000;
              const animationEnd = Date.now() + duration;
              const defaults = { 
                startVelocity: 30, 
                spread: 360, 
                ticks: 60, 
                zIndex: 10000,
                colors: ['#6B7B8C', '#5D7A8C', '#8BA6B8', '#A8C4D9', '#B8A082']
              };

              const randomInRange = (min, max) => Math.random() * (max - min) + min;

              const interval = setInterval(() => {
                const timeLeft = animationEnd - Date.now();

                if (timeLeft <= 0) {
                  return clearInterval(interval);
                }

                const particleCount = 50 * (timeLeft / duration);
                
                // Confetti from the top
                window.confetti({
                  ...defaults,
                  particleCount,
                  origin: { x: randomInRange(0.1, 0.3), y: 0 }
                });
                window.confetti({
                  ...defaults,
                  particleCount,
                  origin: { x: randomInRange(0.7, 0.9), y: 0 }
                });
              }, 250);
            }
          }, 100);
        } catch (error) {
          console.log('Confetti script failed to load:', error);
        }
      };

      triggerConfetti();
    }
  }, [showConfetti]);

  if (!currentBridesmaid) {
    return (
      <div className="bridesmaids-proposal-page">
        <div className="proposal-hero-section d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h1 className="proposal-title">Dama de Honor No Encontrada</h1>
                <p className="proposal-subtitle">La dama de honor que buscas no existe.</p>
                <a href="/bridesmaids" className="btn btn-primary btn-lg">
                  Volver a la Selección de Damas de Honor
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bridesmaids-proposal-page">
      {/* Splash Screen with Photo and Loading Content */}
      <AnimatePresence>
        {showSplash && (
          <motion.div 
            className="bridesmaid-splash-screen"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <div className="background-overlay background"></div>
            <div className="splash-container">
              {/* Background Photo */}
              <img 
                src={currentBridesmaid?.image}
                alt={`${currentBridesmaid?.displayName} - Bridesmaid`}
                className="splash-background-photo"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
              <div 
                className="splash-photo-placeholder d-none"
                style={{ 
                  minHeight: "100vh", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  background: "linear-gradient(135deg, var(--primary-color), var(--secondary-color))",
                }}
              >
                <div className="text-white text-center">
                  <i className="fas fa-user fa-4x mb-3"></i>
                  <h4>{currentBridesmaid?.displayName}</h4>
                  <p className="mb-0">¡Hermosa foto de {currentBridesmaid?.displayName} próximamente!</p>
                </div>
              </div>
              
              {/* Loading Content Overlay */}
              <div className="splash-loading-overlay">
                <div className="splash-loading-content">
                  <div className="loading-icon">
                    <i className="fas fa-heart"></i>
                  </div>
                  <h2 className="loading-title">{currentBridesmaid?.displayName}</h2>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Proposal Card */}
      <AnimatePresence>
        {showCard && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {/* Hero Section */}
            <div className="proposal-hero-section d-flex align-items-center justify-content-center">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <motion.div 
                      className="proposal-card"
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 1 }}
                    >
                <div className="proposal-content">
                  <div className="row align-items-center">
                    {/* Bridesmaid Photo */}
                    {!isMobile && (
                        <div className="col-md-5 col-lg-4 mb-4 mb-md-0">
                        <motion.div 
                          className="bridesmaid-photo-container"
                          initial={{ opacity: 0, x: -30 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.5, delay: 0.05 }}
                        >
                          <div className="bridesmaid-photo-wrapper">
                            <img 
                              src={currentBridesmaid.image}
                              alt={`${currentBridesmaid.displayName} - Bridesmaid`}
                              className="bridesmaid-photo"
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "block";
                              }}
                            />
                            <div 
                              className="photo-placeholder d-none text-center p-4"
                              style={{ 
                                minHeight: "400px", 
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "center",
                                background: "linear-gradient(135deg, var(--primary-color), var(--dusty-blue))",
                                borderRadius: "20px"
                              }}
                            >
                              <div className="text-white">
                                <i className="fas fa-user fa-4x mb-3"></i>
                                <h4>{currentBridesmaid.displayName}</h4>
                                <p className="mb-0">¡Hermosa foto de {currentBridesmaid.displayName} próximamente!</p>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      </div>
                    )}
                    
                    {/* Proposal Content */}
                    <div className="col-md-7 col-lg-8">
                      <motion.div 
                        className="proposal-text"
                        initial={{ opacity: 0, x: 30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                      >
                        {/* Main Proposal */}
                        <AnimatePresence>
                          {showProposal && (
                            <motion.div
                              initial={{ opacity: 0, scale: 0.95 }}
                              animate={{ opacity: 1, scale: 1 }}
                              transition={{ duration: 0.4, ease: "easeOut" }}
                            >
                              <h1 className="proposal-title mb-1">
                                {currentBridesmaid.displayName}
                              </h1>
                              <h2 className="proposal-subtitle mb-4">
                                ¿Serías mi dama?
                              </h2>
                              <p className="proposal-text lead text-center mb-4">
                              Me sentiría honrada de tenerte a mi lado en este día tan especial de mi vida
                              </p>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Confetti Animation - Now handled by ConfettiPage */}

                        {/* Personal Message */}
                        <AnimatePresence>
                          {showProposal && (
                            <motion.div
                              initial={{ opacity: 0, y: 15 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.4, delay: 0.1, ease: "easeOut" }}
                              className="proposal-message"
                            >
                              <div className="message-card p-4 mb-4">
                                <p className="message-text">
                                  {currentBridesmaid.personalMessage}
                                </p>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Dress Code Details */}
                        <AnimatePresence>
                          {showDetails && (
                            <motion.div
                              initial={{ opacity: 0, y: 15 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.4, delay: 0.05, ease: "easeOut" }}
                              className="dress-code-section"
                            >
                              <div className="dress-code-card p-4 mb-4">
                                <h4 className="dress-code-title mb-3">
                                  <i className="fas fa-tshirt me-2"></i>
                                  Código de Vestimenta y Estilo
                                </h4>
                                <div className="dress-details">
                                  <div className="color-sample mb-3">
                                    <div 
                                      className="color-swatch"
                                      style={{ backgroundColor: '#6a7c99' }}
                                    ></div>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                      <span className="color-name ms-3">Slate blue</span>
                                    </div>
                                  </div>
                                  <div className="dress-link mb-3">
                                    <a 
                                      href="https://www.jjshouse.com/en/a-line-cowl-floor-length-stretch-satin-bridesmaid-dress-007298037-g298037?pos=similar_styles_4&filterColor=slate_blue"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-outline-primary btn-sm"
                                    >
                                      <i className="fas fa-shopping-bag me-2"></i>
                                      Ejemplo de vestido
                                    </a>
                                  </div>
                                  <ul className="dress-requirements">
                                    <li>
                                      <i className="fas fa-check me-2"></i>
                                      Tela satinada en color slate blue
                                    </li>
                                    <li>
                                      <i className="fas fa-check me-2"></i>
                                      Vestido largo hasta el suelo, elegante y cómodo
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                      </motion.div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default BridesmaidPersonalPage;
